// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

export const Attendees: React.FC<React.PropsWithChildren<SvgProps>> = (
  props
) => (
  <Svg {...props}>
    <path d="M12.105 12.923c1.596 0 2.895 1.3 2.895 2.895v2.105H6v-2.105c0-1.596 1.299-2.895 2.895-2.895zm3.767.571c.139-.24.447-.32.684-.182.89.517 1.444 1.477 1.444 2.506v1.605c0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5v-1.605c0-.673-.362-1.302-.946-1.641-.238-.138-.32-.444-.182-.683zm-3.767.43h-3.21c-1.045 0-1.895.85-1.895 1.894v1.105h7v-1.105c0-1.045-.85-1.895-1.895-1.895zM10.645 6c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm3.385.488c.096-.259.386-.39.642-.298 1.18.433 1.972 1.562 1.972 2.81s-.793 2.377-1.972 2.81c-.057.02-.115.03-.172.03-.204 0-.396-.126-.47-.328-.095-.26.038-.547.298-.642.787-.288 1.316-1.04 1.316-1.87 0-.83-.529-1.582-1.316-1.87-.26-.095-.393-.383-.298-.642zM10.645 7c-1.104 0-2 .897-2 2s.896 2 2 2c1.103 0 2-.897 2-2s-.897-2-2-2z" />
  </Svg>
);

Attendees.displayName = 'Attendees';

export default Attendees;
